import links from "@/links/links";

export default {
  actions: {
    // NOTE: get the ones that belong to certain building owner
    //       get w/ related building_owner_voting_rights ..
    FETCH(buildingOwnerId) {
      return this.get(links.BUILDING_OWNER_BUILDING_LOT_FETCH(buildingOwnerId), {
        dataKey: "hydra:member",
      });
    },
    POST(item) {
      return this.post(links.BUILDING_OWNER_BUILDING_LOT_POST(), item);
    },
    DELETE(itemId) {
      return this.delete(links.BUILDING_OWNER_BUILDING_LOT_DELETE(itemId), {
        delete: itemId,
      });
    },
  },
};
